import { ExclamationIcon } from "@heroicons/react/outline";


function ErrorView({props}) {

    return (
      <div className="flex items-center">
      <div className="flex justify-center items-center flex-col p-8 space-y-2">
        <div className='mb-6'>
        <ExclamationIcon className='h-20 text-red-500'/>
        </div>
        <p className='text-red-500 text-sm flex flex-1'>Sorry we cannot reach the server at the moment. Please try again later.</p>
        <p className='text-red-500 text-sm flex flex-1'>If this problem persists contanct the system administrator.</p>
      </div>
    </div>
)
}

export default ErrorView;
